/**
 * Convert a pixel value to rem
 *
 * @param {number} value
 * @returns {string}
 */
export function rem(value) {
   const base = window.innerWidth <= 1920 ? 16 : 20;
   return `${value / base}rem`;
}

/**
 * Wrap a element or string in a new element
 *
 * @param {string|Element} element
 * @param {string} tagName
 * @param {string} className
 * @returns {Element}
 */
export function wrap(element, tagName, className) {
   const wrapper = document.createElement(tagName);

   if (typeof className === "string") {
      wrapper.className = className;
   }

   if (typeof element === "string") {
      wrapper.innerText = element;
   } else {
      wrapper.appendChild(element);
   }

   return wrapper;
}

export function isTouchDevice() {
   return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
   );
};

export function getLinkFeatures(anchor) {
   const rel = typeof anchor.rel !== "string" ? [] : anchor.rel.split(" ").map(a => a.trim());
   return {
      noopener: rel.includes("noopener"),
      noreferer: rel.includes("noreferer"),
   };
}

export function createLinkFeatures(features) {
   const items = [];
   if (features && typeof features === "object") {
      Object.keys(features).forEach(key => {
         switch (key) {
            case "noopener":
            case "noreferer":
               if (!!features[key]) {
                  items.push(key);
               }
               break;
            default:
         }
      });
   }
   return items.join(",");
}

export function redirect(url) {
   window.location.href = url;
}

export function openWindow(url, windowName = "", options = {}) {
   window.open(url, windowName, createLinkFeatures(options));
}

export function scrollToTop() {
   document.body.scrollIntoView({ behavior: "smooth" });
}

export function camelCaseToSnakeCase(str) {
   return str.replace(
      /\.?([A-Z]+)/g,
      (x, y) => {
         return "_" + y.toLowerCase()
      }).replace(/^_/, "");
}

export function dashToCamelCase(str) {
   return str.replace(
      /-(.)/g,
      (x, y) => {
         return y.toUpperCase()
      });
}

export function parseDataset(attributes) {
   const result = {};

   Array.from(attributes).forEach(attr => {
      if (attr.name.startsWith("data-")) {
         try {
            const prop = dashToCamelCase(attr.name.replace(/^data-/, ""));
            if (attr.value.includes("{")) {
               result[prop] = JSON.parse(attr.value.replace(/'/g, '"'));
            } else if (/^\d+$/.test(attr.value)) {
               result[prop] = parseFloat(attr.value);
            } else {
               result[prop] = attr.value;
            }
         } catch (error) {
            console.error(error);
         }
      }
   });
   return result;
}
